<div class="dialog">
  @if (data.titleKey) {
    <div class="title mat-title-large">{{data.titleKey | translate}}</div>
  }
  <div>
    {{data.messageKey | translate: data.messageData}}
  </div>
  @if (confirmation(); as confirmation) {
    <div class="actions">
      <button mat-button [disabled]="data.self || voted" (click)="vote(false)">{{'common.no' | translate}} ({{confirmation?.denied}}/{{confirmation?.target}})</button>
      <button mat-flat-button color="primary" [disabled]="data.self || voted" (click)="vote(true)">{{'common.yes' | translate}} ({{confirmation?.confirmed}}/{{confirmation?.target}})</button>
    </div>
  }
</div>
